import { EventEmitter } from '@angular/core';
import { Component, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'cass-simple-text-editor',
	templateUrl: './simple-text-editor.component.html',
	styleUrls: ['./simple-text-editor.component.css']
})
export class SimpleTextEditorComponent implements OnInit {

	@Input()
	initialContent?: string | undefined;

	@Input()
	get edtorContent(): string | undefined {
		return this._edtorContent;
	}
	set edtorContent(edtorContent: string | undefined) {
		if (this._edtorContent !== edtorContent) {
			this._edtorContent = edtorContent;
			this.contentChanged.emit(this._edtorContent);
		}
	}
	private _edtorContent: string | undefined;

	@Output()
	contentChanged = new EventEmitter<string>();

	constructor() { }

	ngOnInit(): void {
		this.edtorContent = this.initialContent;
	}
}
